/**
 * Created by joerg on 01.06.17.
 */
import packageJson from '../../package.json';
import numeral from 'numeral/numeral'
import 'numeral/locales'
export default class Utils {

    static get serverpath(){
        let comps = packageJson.homepage.split('/');
        return comps[comps.length-1];
    }

    static stripTags(str,repl=' '){
        str = str.toString();
        return str.replace(/<[^>]*>/g, repl);
    }

    static getDataUri(url, callback) {
        var image = new Image();

        image.onload = function () {
            var canvas = document.createElement('canvas');
            canvas.width = this.naturalWidth*4; // or 'width' if you want a special/scaled size
            canvas.height = this.naturalHeight*4; // or 'height' if you want a special/scaled size

            canvas.getContext('2d').drawImage(this, 0, 0,this.naturalWidth*4,this.naturalHeight*4);

            // Get raw image data
            //callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''));

            // ... or get as Data URI
            callback(canvas.toDataURL('image/png'));
        };

        image.src = url;
    }
    static roundToTwo(num) {
        return +(Math.round(num + "e+2")  + "e-2");
    }

    static regde(){
        numeral.register('locale', 'de2', {
            delimiters: {
                thousands: '.',
                decimal: ','
            },
            abbreviations: {
                thousand: 'k',
                million: 'm',
                billion: 'b',
                trillion: 't'
            },
            ordinal: function (number) {
                return '.';
            },
            currency: {
                symbol: '€'
            }
        });
    }
    static formatNumber(num){

       numeral.locale('de2');
        //numeralDE.delimiters.thousands = '.';
        //numeral.language('de2', numeralDE);
        //numeral.language('de2');
       // numeral.language('de', window.jQuery.extend(numeralDE, { delimiters: {thousands: '.', decimal: ','} }));
        let fm = numeral(num).format('0,0.00') ;

        return fm
    }
    static rAndF(num){
        return(Utils.formatNumber(Utils.roundToTwo(num)));
    }
    static rAndFNoDec(num){
        return (numeral(num).format('0,0')) ;
    }

    static hoursfromMinutes(n) {
        var num = n;
        var hours = (num / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        return num + " minutes = " + rhours + " hour(s) and " + rminutes + " minute(s).";
    }


    static normalizeAddonWidths(rootElement='document'){
        let maxwleft = 0;
        let maxwbutton = 0;
        let maxwright = 0;
       // let maxwinput = 0;
        let parent = window.jQuery(rootElement).find('.input-group')[0];
        var parentwidth = 100
        if(parent){

             parentwidth = window.jQuery(parent.parentElement).width();
        }
        let addonsLeft = window.jQuery(rootElement).find('.left-addon');

        addonsLeft.each(function(i,elem){
            let tw = window.jQuery(elem).outerWidth();

            maxwleft = Math.max(tw,maxwleft);
        });

        //addonsLeft.css({width:maxwleft});
        addonsLeft.outerWidth(maxwleft);

        let elemsdd = window.jQuery(rootElement).find('.btn-group .btn');
        elemsdd.each(function(i,elem){
            maxwbutton = Math.max(window.jQuery(elem).width(),maxwbutton);
        });
        elemsdd.width(Math.min(parentwidth-maxwbutton,maxwbutton));
        elemsdd.each(function(i,elem){
            //window.jQuery(elem).height(window.jQuery(elem.parentElement.parentElement).height());
        });


        let elemsright = window.jQuery(rootElement).find('.right-addon');
        elemsright.each(function(i,elem){
            maxwright = Math.max(window.jQuery(elem).width(),maxwright);
        });
        elemsright.width(maxwright);

        let elemsinput = window.jQuery(rootElement).find('.input-group .sizeinput');
        /*elemsinput.each(function(i,elem){
            maxwinput = Math.max(window.jQuery(elem).width(),maxwinput);
        });
        maxwinput = Math.min(maxwinput, parentwidth - maxwright - maxwleft);*/
        elemsinput.each(function(i,elem){
            //elemsinput.width(maxwinput);
           // elemsinput.height(window.jQuery(elem.previousElementSibling).height());
        });
        let elemsinputheight = window.jQuery(rootElement).find('.input-group .size-input-height');
        elemsinputheight.each(function(i,elem){
            window.jQuery(elem).height(window.jQuery(elem.previousElementSibling).height());
        });

        //console.log(maxwleft,maxwbutton,maxwright,maxwinput)
    }

    static polyfillArray(){
        if (!Array.from) {
            Array.from = (function () {
                var toStr = Object.prototype.toString;
                var isCallable = function (fn) {
                    return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
                };
                var toInteger = function (value) {
                    var number = Number(value);
                    if (isNaN(number)) { return 0; }
                    if (number === 0 || !isFinite(number)) { return number; }
                    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
                };
                var maxSafeInteger = Math.pow(2, 53) - 1;
                var toLength = function (value) {
                    var len = toInteger(value);
                    return Math.min(Math.max(len, 0), maxSafeInteger);
                };

                // The length property of the from method is 1.
                return function from(arrayLike/*, mapFn, thisArg */) {
                    // 1. Let C be the this value.
                    var C = this;

                    // 2. Let items be ToObject(arrayLike).
                    var items = Object(arrayLike);

                    // 3. ReturnIfAbrupt(items).
                    if (arrayLike == null) {
                        throw new TypeError('Array.from requires an array-like object - not null or undefined');
                    }

                    // 4. If mapfn is undefined, then let mapping be false.
                    var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
                    var T;
                    if (typeof mapFn !== 'undefined') {
                        // 5. else
                        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                        if (!isCallable(mapFn)) {
                            throw new TypeError('Array.from: when provided, the second argument must be a function');
                        }

                        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                        if (arguments.length > 2) {
                            T = arguments[2];
                        }
                    }

                    // 10. Let lenValue be Get(items, "length").
                    // 11. Let len be ToLength(lenValue).
                    var len = toLength(items.length);

                    // 13. If IsConstructor(C) is true, then
                    // 13. a. Let A be the result of calling the [[Construct]] internal method
                    // of C with an argument list containing the single item len.
                    // 14. a. Else, Let A be ArrayCreate(len).
                    var A = isCallable(C) ? Object(new C(len)) : new Array(len);

                    // 16. Let k be 0.
                    var k = 0;
                    // 17. Repeat, while k < len… (also steps a - h)
                    var kValue;
                    while (k < len) {
                        kValue = items[k];
                        if (mapFn) {
                            A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                        } else {
                            A[k] = kValue;
                        }
                        k += 1;
                    }
                    // 18. Let putStatus be Put(A, "length", len, true).
                    A.length = len;
                    // 20. Return A.
                    return A;
                };
            }());
        }
    }

}


// WEBPACK FOOTER //
// ./src/utils/Utils.js